@use '../@shared/mixins' as *;
@use '../@shared/global' as *;
@use '../@shared/icon.mixin' as *;

@layer kol-component {
	@include kol-icon-styles();

	.kol-tree-item {
		$root: &;

		&__link {
			.kol-link {
				display: inline-flex;
				min-height: var(--a11y-min-size);
				align-items: center;

				text-decoration: none;
			}
		}

		&__link-inner {
			display: flex;
			align-items: center;
		}

		&__children {
			margin: 0;
			padding: 0;
			list-style: none;
		}

		.kol-span {
			place-items: unset; // unset 'center' style from global layer
		}

		&__toggle-button,
		&__toggle-button-placeholder {
			display: inline-flex;
			min-width: var(--a11y-min-size);
			min-height: var(--a11y-min-size);
			align-items: center;
			justify-content: center;
		}

		&__text {
			text-decoration: underline;
		}
	}
}
